import { sentCard, waitingFiles } from '../import-requests'
import { getMe } from '../me'
import { routeGen } from '../route-state'
import { clear, el } from '../ui'

// The first thing a new round sees (#/start, straight after "Set up my round";
// Liam 2026-09-26: onboarding "super clear and easy", adapting to "so many
// different systems"). One question, three answers, each going straight to
// the quickest way in for where their customers are now. The diary's welcome
// box carries on from here.
export function mountStart(): void {
  const root = document.querySelector<HTMLElement>('#screen')!
  clear(root)
  const me = getMe()
  const first = me?.workerName?.trim()
  root.append(
    el(
      'div',
      { class: 'page-heading' },
      el('div', {}, el('h2', {}, first ? `Welcome to Roundly, ${first}` : 'Welcome to Roundly'), el('p', { class: 'muted' }, "Let's get your customers in. Where are they now?")),
    ),
  )
  const choice = (href: string, title: string, detail: string): HTMLElement =>
    el('a', { href, class: 'start-choice' }, el('strong', {}, title), el('span', {}, detail), el('span', { class: 'start-go', 'aria-hidden': 'true' }, '›'))
  root.append(
    el(
      'div',
      { class: 'start-choices' },
      choice('#/import', 'In a spreadsheet or another app', 'Bring them all in at once from Excel, Google Sheets, Numbers or the file another app gives you.'),
      // A round kept in the phone's calendar (Liam's brother, Apple Calendar, 30 Sep 2026). Roundly cannot read a
      // calendar yet, so this is the help-by-email route, promising help, not an import (Astra).
      el('a', { href: `mailto:hello@roundly.work?subject=${encodeURIComponent(`My customers are in my phone's calendar${me?.settings?.business_name ? ` (${me.settings.business_name})` : ''}`)}&body=${encodeURIComponent("Hi,\nMy customers are in my phone's calendar. Here is what I have (screenshots or an export attached).\nThanks")}`, class: 'start-choice' },
        el('strong', {}, "On my phone's calendar"),
        el('span', {}, 'Email us what you have and we will help get your customers in. Free.'),
        el('span', { class: 'start-go', 'aria-hidden': 'true' }, '›')),
      // Straight into the first job (19 Oct 2026: "It needs to feel easy to book in the first customer"); Work's add row stays for the rest.
      choice('#/schedule?firstjob=1', 'In a notebook or on my phone', 'Book your first job: who it is for, when, and how much. Add the rest as you go.'),
      choice('#/schedule', "I'm just starting out", 'Go to your diary. Add customers as you win them.'),
      // We do it for them (Liam 28 Sep 2026: free; 1 Oct 2026: "within 2 working days"). Since 1 Oct
      // the file is sent privately from the import screen's "Send us your file" (0039), not by email.
      choice('#/import?send=1', 'Send it to us and we will put them in', 'Send us the file from your old app or spreadsheet. Free, within 2 working days.'),
    ),
    el('p', { class: 'muted start-later' }, 'You can come back to this from the welcome box on your diary.'),
  )
  // They said at sign-up they work with others (0073; Liam picked B, 15 Oct 2026): where to add them, under the above.
  if (me?.worksWith === 'others' && me.role === 'owner') {
    root.append(el('a', { href: '#/people', class: 'start-choice start-people' },
      el('strong', {}, 'Add the people who work with you'),
      el('span', {}, 'Each one signs in with a code sent to their email and sees their own jobs. Free.'),
      el('span', { class: 'start-go', 'aria-hidden': 'true' }, '›')))
  }
  // A file already sent: say so at the top, so nobody sends it twice wondering.
  const gen = routeGen
  void waitingFiles().then((waiting) => {
    if (gen !== routeGen || !waiting.length || !root.isConnected) return
    const heading = root.querySelector('.page-heading')
    heading?.after(el('div', { class: 'start-sent' }, ...waiting.slice(0, 1).map((r) => sentCard(r))))
  })
}
